import { render, staticRenderFns } from "./MainEncyclopediaCategories.vue?vue&type=template&id=50cda206&scoped=true&"
import script from "./MainEncyclopediaCategories.vue?vue&type=script&lang=js&"
export * from "./MainEncyclopediaCategories.vue?vue&type=script&lang=js&"
import style0 from "./MainEncyclopediaCategories.vue?vue&type=style&index=0&id=50cda206&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cda206",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainEncyclopediaCategories: require('/web/components/MainEncyclopediaCategories.vue').default})
